module.exports = __webpack_public_path__ + "img/TM.eaa250b1.svg";